export function substituteRatingUrl(
  pattern: string,
  value: string | number
): string {
  if (!pattern) return "";
  return pattern.replace(/\{value\}/g, String(value));
}

export function resolveSegmentHref(
  block: any,
  segment: { attributes: Record<string, any> }
): string {
  const mode = block?.url?.mode ?? "pattern";
  if (mode === "individual") {
    return segment.attributes["href"] || "";
  }
  return substituteRatingUrl(
    block?.urlPattern || "",
    segment.attributes["value"] ?? ""
  );
}
